import axios from "axios";

import { auth } from "@/auth";
import store from "@/store/root";
import { Coding } from "@/tools/msa/models/codes";
import { Response } from "@/tools/msa/models/requests/encoding";

export const encodeTextWithIcd = async (text: string): Promise<Coding[]> => {
  return await axios
    .post<Response>(
      (store.state as any).settings.current.endpoints.encode,
      text,
      { headers: await auth.headers(), timeout: 1000 }
    )
    .then(response => response.data)
    .then(data =>
      data.icd.imatches.map(
        (match): Coding => ({
          code: match.code,
          system: match.codeset,
          display: match.codename,
          type: match.codetype
        })
      )
    )
    .catch(error => {
      console.error(
        "couldn't communicate with icd-10-cm encode endpoint:",
        error
      );
      return [];
    });
};
